import jDataConnectivityList from '@/views/data-connectivity/jDataConnectivityList';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/data-connectivity',
    name: 'jDataConnectivityList',
    component: jDataConnectivityList,
    meta: {
      title: 'Data Connectivity',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterDataConnectivity.js